var map = {
	"./主修科目.png": 9259,
	"./作文批改.png": 9005,
	"./其他科目.png": 8594,
	"./化学.png": 1565,
	"./历史.png": 1883,
	"./口算.png": 4126,
	"./地理.png": 4746,
	"./必修科目.png": 7621,
	"./政治.png": 6066,
	"./数学.png": 6602,
	"./物理.png": 7897,
	"./生物.png": 9460,
	"./英语.png": 5465,
	"./计算.png": 7205,
	"./识物英语.png": 4760,
	"./语文.png": 250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 971;